import { z } from "zod";

export interface IdentityServiceConfig {
	baseUrl: string;
}

export function loadIdentityServiceConfig(): IdentityServiceConfig {
	const env = validateEnvironment();

	return {
		baseUrl: env.IDENTITY_SERVICE
	};
}

function validateEnvironment() {
	const envSchema = z.object({
		IDENTITY_SERVICE: z.string({
			required_error: "IDENTITY_SERVICE environment variable is missing"
		})
	});

	const parsed = envSchema.safeParse(process.env);

	if (!parsed.success) {
		throw new Error(parsed.error.errors.map((e) => e.message).join("\n"));
	}

	return parsed.data;
}
